function queryParameter(param) {
  return new URLSearchParams(window.location.search).get(param)
}

export default queryParameter
